export default [
  {
    path: '',
    name: 'courier list',
    component: () => import('@/views/app/courier/page-list.vue'),
    meta: { title: 'Daftar Kurir' },
  },
]
